import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'orderinfo',
  data: function data() {
    return {
      searchForm: {
        orderId: '',
        payState: ''
      },
      tableData: [],
      loading: false
    };
  },
  mounted: function mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData: function loadTableData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.loading = true;
                params = new URLSearchParams();
                params.set('orderId', _this.searchForm.orderId);
                params.set('payState', _this.searchForm.payState);
                params.set('pageIndex', 1);
                params.set('pageSize', 50);
                _context.next = 9;
                return _this.$api.loadOrderInfo(params.toString());

              case 9:
                res = _context.sent;
                res.content.forEach(function (e) {
                  e.money = (e.money / 100).toFixed(2);
                });
                _this.tableData = res.content;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 17:
                _context.prev = 17;
                _this.loading = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14, 17, 20]]);
      }))();
    },
    handleSearchFormSubmit: function handleSearchFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadTableData();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    formatPayState: function formatPayState(row, column, cellValue, index) {
      switch (row.payState) {
        case 0:
          return '未支付';

        case 1:
          return '支付中';

        case 2:
          return '已支付';

        case 3:
          return '支付失败';

        default:
          return '未知';
      }
    },
    formateMoney: function formateMoney(row, column, cellValue, index) {
      return (row.payMoney / 100).toFixed(2);
    }
  }
};